<script setup lang="tsx">
import { ref, type Ref } from 'vue'

withDefaults(
	defineProps<{
		canSave?: Ref<boolean>
		saveId: string
		cancelId: string
	}>(),
	{
		canSave: () => ref(true),
	},
)
const emit = defineEmits(['cancel', 'save'])
</script>

<template>
	<div class="d-flex gap-2">
		<button :data-test="cancelId" class="btn btn-secondary flex-fill" @click="emit('cancel')">{{ $t('misc.cancel') }}</button>
		<button :data-test="saveId" class="btn btn-primary flex-fill" @click="emit('save')" :disabled="!canSave.value">
			{{ $t('misc.save') }}
		</button>
	</div>
</template>
